import { render, staticRenderFns } from "./EditarMensagem.vue?vue&type=template&id=4ad917fa&"
import script from "./EditarMensagem.vue?vue&type=script&lang=js&"
export * from "./EditarMensagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports